import { Desktop } from '@99designs/common/components/Desktop';
import { Icon } from '@99designs/common/components/Icon';
import { Mobile } from '@99designs/common/components/Mobile';
import ImageTile from 'launch/components/ImageTile';
import React from 'react';

interface Props {
    url: string;
    title: string;
}

class BriefEntryAction extends React.Component<Props> {
    render() {
        const { url, title } = this.props;

        return (
            <>
                <Desktop>
                    <ImageTile
                        imagePadding={true}
                        textWidth="narrow"
                        textSize="large"
                        url={url}
                        title={title}
                    />
                </Desktop>
                <Mobile>
                    <div className="brief-entry-action">
                        <div className="brief-entry-action__title">{title}</div>
                        <Icon type={'right-2'} variations={['large']} />
                    </div>
                </Mobile>
            </>
        );
    }
}

export default BriefEntryAction;
